'use client'

import { useEffect, useState } from 'react'
import { useSocket } from './SocketProvider'

/**
 * Индикатор статуса WebSocket-подключения.
 * Подписывается на socket-события напрямую — ре-рендерится только сам,
 * не вызывая ре-рендер всего дерева компонентов.
 * 
 * Всегда виден: зелёная точка = подключен, жёлтая = подключение, красная = отключен.
 */
export function WsStatusIndicator() {
  const { socket } = useSocket()
  const [status, setStatus] = useState<'connecting' | 'connected' | 'disconnected'>('connecting')

  useEffect(() => {
    if (!socket) {
      setStatus('connecting')
      return
    }

    // Устанавливаем начальный статус
    setStatus(socket.connected ? 'connected' : 'connecting')

    const onConnect = () => setStatus('connected')
    const onDisconnect = () => setStatus('disconnected')

    socket.on('connect', onConnect)
    socket.on('disconnect', onDisconnect)

    return () => {
      socket.off('connect', onConnect)
      socket.off('disconnect', onDisconnect)
    }
  }, [socket])

  const color = status === 'connected' ? '#2E8B57' : status === 'connecting' ? '#F59E0B' : '#EF4444'
  const label = status === 'connected' ? 'WS' : status === 'connecting' ? '...' : 'x'

  return (
    <div style={{
      position: 'fixed',
      bottom: 12,
      right: 12,
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      padding: '4px 8px',
      borderRadius: 6,
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(139, 90, 43, 0.15)',
      fontSize: 10,
      color: '#999',
      zIndex: 9999,
      pointerEvents: 'none',
      lineHeight: 1,
    }}>
      <span style={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: color,
        flexShrink: 0,
      }} />
      <span>{label}</span>
    </div>
  )
}
